import React, { useMemo } from 'react';
import { AiComponentHtmlContent } from '@/pkg/ai';
import { StackedInputGroupWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { HtmlContentRichTextInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/html-content/html-content-rich-text-input';
import { HtmlContentTextAreaInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/html-content/html-content-text-area-input';

export interface GenericHtmlContentInput {
  component: AiComponentHtmlContent;
  getHtmlContent: (selector: string) => string;
  setHtmlContent: (selector: string, html: string) => void;
  getTextContent: (selector: string) => string;
  setTextContent: (selector: string, text: string) => void;
}

export function GenericHtmlContentInput({
  component,
  getHtmlContent,
  setHtmlContent,
  getTextContent,
  setTextContent,
}: GenericHtmlContentInput) {
  const textValue = useMemo(
    () => getTextContent(component.selector),
    [component, getTextContent],
  );

  const htmlValue = useMemo(
    () => getHtmlContent(component.selector),
    [component, getHtmlContent],
  );

  const onTextChange = (value: string) => {
    setTextContent(component.selector, value);
  };

  const onHtmlChange = (value: string) => {
    setHtmlContent(component.selector, value);
  };

  const toolbarId = useMemo(
    () => component.name + Math.random().toString(36).substring(2, 15),
    [],
  );

  return (
    <StackedInputGroupWrapper style={{ padding: 0 }}>
      {component.richText && (
        <HtmlContentRichTextInput
          id={toolbarId}
          value={htmlValue}
          onChange={onHtmlChange}
        />
      )}
      {!component.richText && (
        <HtmlContentTextAreaInput value={textValue} onChange={onTextChange} />
      )}
    </StackedInputGroupWrapper>
  );
}
